import { useLocation } from "react-router-dom";
import { useMemo } from "react";
export function useTypedState(route) {
    const location = useLocation();
    return useMemo(() => route.getTypedState(location.state), [route, location.state]);
}
